"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _transport = _interopRequireDefault(require("../../transport/transport.xhr"));

var _sync = require("./sync.constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _operationalCacheStorage = {},
    _cacheExpireTimers = {},
    _runningXHR = {},
    operationalCache = {
  get: function get(key) {
    return _operationalCacheStorage[key] || null;
  },
  set: function set(key, data) {
    if (key) {
      _operationalCacheStorage[key] = data;
    }

    return _operationalCacheStorage[key] || null;
  },
  remove: function remove(key) {
    delete _operationalCacheStorage[key];
  }
},
    defaultOptions = {
  cacheLiveTime: 60000
};

var _default =
/*#__PURE__*/
function () {
  function _default() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, _default);
    this.options = _objectSpread({}, defaultOptions, {}, options);
    this.protocol = options.protocol;
    this.url = options.url;
    this.Transport = options.transport || _transport["default"];
  }

  (0, _createClass2["default"])(_default, [{
    key: "post",
    value: function post(options) {
      return this.query(options, 'post');
    }
  }, {
    key: "put",
    value: function put(options) {
      return this.query(options, 'put');
    }
  }, {
    key: "delete",
    value: function _delete(options) {
      return this.query(options, 'delete');
    }
  }, {
    key: "get",
    value: function get(options) {
      return this.query(options, 'get');
    }
  }, {
    key: "close",
    value: function close() {
      return this.xhr && this.xhr.close();
    }
  }, {
    key: "query",
    value: function query() {
      var _this = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';

      var // copy for modification
      queryOptions = _objectSpread({}, this.options, {}, options),
          queryId = this._getQueryId(queryOptions);

      var _queryOptions$data = queryOptions.data,
          data = _queryOptions$data === void 0 ? {} : _queryOptions$data; // force unique query ID

      if (queryOptions.force) {
        this._clearCache(queryId);
      } // рандом параметр для IOS 6+, который кеширует пост запросы


      if (method && method.toLowerCase() === 'post') {
        if (data instanceof FormData) {
          data.append('_', new Date().getTime());
        } else if ((0, _typeof2["default"])(data) === 'object') {
          data._ = new Date().getTime();
        }
      } // наличие кеша


      var cachedData = this._getCache(queryId, queryOptions);

      if (cachedData) {
        try {
          return this._success(queryOptions, cachedData).then(function (packet) {
            return Promise.resolve(packet && packet.data);
          });
        } catch (e) {
          return Promise.reject(new Error('Sync XHR. Cannot resolve data from query cache.'));
        }
      }

      if (queryOptions.contentType === 'application/json') {
        data = JSON.stringify(data); // alias for migration from jquery to axios

        queryOptions.headers = queryOptions.headers || {};
        queryOptions.headers['Content-Type'] = queryOptions.contentType;
      }

      if (queryOptions.dataType) {
        // alias for migration from jquery to axios
        queryOptions.responseType = queryOptions.dataType;
      }

      if (!_runningXHR[queryId]) {
        this.xhr = new this.Transport(queryOptions.url || this.url, queryOptions);
        var xhrCall;

        if (typeof this.xhr[method] !== 'function') {
          return Promise.reject(new Error("Sync XHR. Transport method ".concat(method, " not found.")));
        }

        _runningXHR[queryId] = new Promise(function (resolve, reject) {
          if (method === 'get') {
            xhrCall = _this.xhr[method](queryOptions);
          } else {
            xhrCall = _this.xhr[method](data, queryOptions);
          }

          xhrCall.then(function (response) {
            if (queryOptions.cacheResponse) {
              _this._cache(queryId, queryOptions, response.data || {});
            }

            return _this._success(queryOptions, response.data || {});
          }, function (error) {
            return _this._error(queryOptions, error);
          }).then(function (packet) {
            resolve(packet && packet.data);
            delete _runningXHR[queryId];
          }, function (packet) {
            reject(packet);
            delete _runningXHR[queryId];
          });
        });
      }

      return _runningXHR[queryId];
    }
  }, {
    key: "_success",
    value: function _success(queryOptions, data) {
      var packet; // parse response by protocol rules

      if (typeof queryOptions.protocol === 'function') {
        packet = this._parseProtocol(data, queryOptions.protocol);
      } else if (this.protocol) {
        packet = this._parseProtocol(data, this.protocol);
      } else {
        packet = {
          status: _sync.responseState.SUCCESS,
          data: data
        };
      } // response is invalid by protocol rules


      if (packet.status === _sync.responseState.ERROR) {
        return Promise.reject(packet);
      } else if (packet.status === _sync.responseState.SUCCESS) {
        return Promise.resolve(packet);
      }
    }
  }, {
    key: "_error",
    value: function _error(queryOptions) {
      var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var packet,
          response = error.response || {}; // server sent valid error response

      if (response && response.data) {
        // parse response by protocol rules
        if (typeof queryOptions.protocol === 'function') {
          packet = this._parseProtocol(response.data, queryOptions.protocol);
        } else if (this.protocol) {
          packet = this._parseProtocol(response.data, this.protocol);
        } else {
          packet = {
            status: response.status || _sync.responseState.ERROR,
            message: response.data.message || response.message || response.statusText
          };
        }
      } else if ((0, _typeof2["default"])(response) === 'object') {
        packet = _objectSpread({}, response, {
          message: error.message || response.statusText
        });
      } else {
        packet = {
          status: _sync.responseState.ERROR,
          message: error.message
        };
      }

      return Promise.reject(packet);
    }
  }, {
    key: "_parseProtocol",
    value: function _parseProtocol(response, protocol) {
      if (typeof protocol === 'function') {
        return protocol(response);
      } else {
        return {};
      }
    }
  }, {
    key: "_cache",
    value: function _cache(key, querySettings, data) {
      var _this2 = this;

      var _querySettings$cacheO = querySettings.cacheOptions,
          cacheOptions = _querySettings$cacheO === void 0 ? {} : _querySettings$cacheO,
          cacheStorage = cacheOptions.storage || operationalCache;
      var dataString; // deep copy for save original response

      try {
        dataString = JSON.stringify(data);
      } catch (e) {
        dataString = '';
      }

      if (typeof cacheStorage.set === 'function') {
        cacheStorage.set(key, dataString);
        clearTimeout(_cacheExpireTimers[key]);
        _cacheExpireTimers[key] = setTimeout(function () {
          return _this2._clearCache(key, cacheStorage);
        }, cacheOptions.time || this.options.cacheLiveTime);
      }
    }
  }, {
    key: "_clearCache",
    value: function _clearCache(key) {
      var storage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : operationalCache;

      if (key && storage && typeof storage.remove === 'function') {
        storage.remove(key);
      }
    }
  }, {
    key: "_getCache",
    value: function _getCache(key, querySettings) {
      var _querySettings$cacheO2 = querySettings.cacheOptions,
          cacheOptions = _querySettings$cacheO2 === void 0 ? {} : _querySettings$cacheO2,
          cacheStorage = cacheOptions.storage || operationalCache;
      var result = null;

      if (typeof cacheStorage.get === 'function') {
        result = cacheStorage.get(key);

        try {
          result = JSON.parse(result);
        } catch (e) {
          result = null;
        }
      }

      return result;
    }
  }, {
    key: "_getQueryId",
    value: function _getQueryId() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return options.cacheOptions && options.cacheOptions.id || options.url + JSON.stringify(options.data || {});
    }
  }]);
  return _default;
}();

exports["default"] = _default;